import { sendReqToController } from "../network";
import { BaseResponse, QuerySchema } from "../base";
import { RegisterMediaOnCMSParams, CustomDataParams } from "./model";
import { isSocketCall } from "@/utils";

// Data could be null or object as Per Backend
interface RespMediaOnCMS extends BaseResponse {
  data: {
    id: string;
    media: string;
    exists: boolean;
  } | null;
}

export const RegisterMediaOnCMSApi = async (
  params: RegisterMediaOnCMSParams,
  method: string
): Promise<RespMediaOnCMS> => {
  const response = await sendReqToController(method, params, isSocketCall);
  return {
    data: response.result,
    error: response.error,
    status: response.code,
  };
};

//To Upload Custom Media
export const RegisterCustomMediaOnCMSApi = async (
  params: CustomDataParams
): Promise<any> => {
  const response = await sendReqToController(
    "media.register",
    params,
    isSocketCall
  );
  return {
    data: response.result,
    error: response.error,
    status: response.code,
  };
};

export const GetUserBucketListApi = async (params: any): Promise<any> => {
  const query: QuerySchema = {
    size: 1000,
  };
  query.must = {
    ...query.must,
    ...(params?.team !== undefined && { team: params.team }),
    ...(params?.status !== undefined && { status: params.status }),
  };
  const response = await sendReqToController(
    "buckets.list",
    query,
    isSocketCall
  );
  return {
    data: response.result,
    error: response.error,
    status: response.code,
  };
};
//To Upload Custom Media
export const denmarkDetailApi = async (
  detailId: string,
  hostId: number,
  isall?: boolean
): Promise<any> => {
  const params: any = {
    sectionid: detailId,
    hostid: hostId.toString(),
    //sectionid: '124287123',
    //hostid: '83',
  };
  if (isall) {
    params.isall = true;
  }

  const response = await sendReqToController(
    "denmark.seodetails",
    params,
    isSocketCall
  );
  return {
    data: Array.isArray(response.result) ? response.result[0] : response.result,
    error: response.error,
    status: response.code,
  };
};

export const denMarkArticleGetApi = async (
  detailId: string,
  hostId: number
): Promise<any> => {
  const params: any = {
    sectionid: detailId,
    hostid: hostId?.toString(),
  };
  const response = await sendReqToController(
    "denmark.articleget",
    params,
    isSocketCall
  );
  return {
    data: Array.isArray(response.result) ? response.result[0] : response.result,
    error: response.error,
    status: response.code,
  };
};
